export default ({ t, accountScopedRoute }) => ({
  name: 'Reports',
  label: t('SIDEBAR.REPORTS'),
  icon: 'i-ph-chart-line',
  children: [
    {
      name: 'Report Overview',
      label: t('SIDEBAR.REPORTS_OVERVIEW'),
      to: accountScopedRoute('account_overview_reports'),
    },
    {
      name: 'Report Conversation',
      label: t('SIDEBAR.REPORTS_CONVERSATION'),
      to: accountScopedRoute('conversation_reports'),
    },
    {
      name: 'Reports Agent',
      label: t('SIDEBAR.REPORTS_AGENT'),
      to: accountScopedRoute('agent_reports_index'),
      activeOn: ['agent_reports_show'],
    },
    {
      name: 'Reports Label',
      label: t('SIDEBAR.REPORTS_LABEL'),
      to: accountScopedRoute('label_reports_index'),
    },
    {
      name: 'Reports Inbox',
      label: t('SIDEBAR.REPORTS_INBOX'),
      to: accountScopedRoute('inbox_reports_index'),
      activeOn: ['inbox_reports_show'],
    },
    {
      name: 'Reports Team',
      label: t('SIDEBAR.REPORTS_TEAM'),
      to: accountScopedRoute('team_reports_index'),
      activeOn: ['team_reports_show'],
    },
    {
      name: 'Reports CSAT',
      label: t('SIDEBAR.CSAT'),
      to: accountScopedRoute('csat_reports'),
    },
    {
      name: 'Reports SLA',
      label: t('SIDEBAR.REPORTS_SLA'),
      to: accountScopedRoute('sla_reports'),
    },
    {
      name: 'Reports Bot',
      label: t('SIDEBAR.REPORTS_BOT'),
      to: accountScopedRoute('bot_reports'),
    },
  ],
});
